// How the backend reports who ended a chat.
export enum ChatEndedByType {
    Customer = 1,
    Agent = 2,
    System = 3,
}

export default ChatEndedByType;
